var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCircleExclamation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "circle-exclamation"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.3334 2C6.80994 2 2.33337 6.47656 2.33337 12C2.33337 17.5234 6.80994 22 12.3334 22C17.8568 22 22.3334 17.5234 22.3334 12C22.3334 6.47656 17.8568 2 12.3334 2ZM12.3334 20.75C7.50916 20.75 3.58337 16.8242 3.58337 12C3.58337 7.17578 7.50916 3.25 12.3334 3.25C17.1576 3.25 21.0834 7.17578 21.0834 12C21.0834 16.8242 17.1576 20.75 12.3334 20.75ZM12.3334 13.875C12.6788 13.875 12.9584 13.5955 12.9584 13.25V7C12.9584 6.65453 12.6788 6.375 12.3334 6.375C11.9879 6.375 11.7084 6.65625 11.7084 7V13.25C11.7084 13.5938 11.9896 13.875 12.3334 13.875ZM12.3334 15.4375C11.8158 15.4375 11.3959 15.8574 11.3959 16.375C11.3959 16.8926 11.8158 17.3125 12.3334 17.3125C12.851 17.3125 13.2709 16.8926 13.2709 16.375C13.2709 15.8574 12.8529 15.4375 12.3334 15.4375Z",
    fill: "#C71717"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleExclamation);
export default __webpack_public_path__ + "static/media/circle-exclamation.35708833c93e7703dab5d18c3978e6ae.svg";
export { ForwardRef as ReactComponent };